<template>
  <div>
    <div v-if="!disabled">
      <div class="title-text">{{ $t('message.refuse.klarnaRebutDrawer.stepTwoTitle') }}</div>
      <div class="title-text title-large">{{ $t('message.refuse.klarnaRebutDrawer.fillRebuttalTitleTwo') }}</div>
      <div class="title-text">{{ $t('message.refuse.klarnaRebutDrawer.fillRebuttalDescTwo') }}</div>
    </div>

    <div v-if="!disabled">
      <!-- 货品上传 -->
      <shipping-upload v-if="goodType !== '4'" :disabled="disabled" class="card" :data="shippingFileListState" :goodType="goodType" @update:data="shippingFileListState = $event"></shipping-upload>
      <!-- 其他上传 -->
      <other-upload :disabled="disabled" class="card" :data="otherFileListState" @update:data="otherFileListState = $event"></other-upload>
    </div>
    <div v-if="disabled">
      <!-- 下载全部, 只有当其他上传有数据时才显示 -->
      <download-all :disabled="disabled" class="card" :id="id" :data="[...shippingFileListState, ...otherFileListState]"></download-all>
    </div>
  </div>
</template>

<script>
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import DownloadAll from '@/views/transaction/refuse-manage/klarna-rebut/components/form/downloadAll/index.vue';
import OtherUpload from '@/views/transaction/refuse-manage/klarna-rebut/components/form/otherUpload/index.vue';
import ShippingUpload from '@/views/transaction/refuse-manage/klarna-rebut/components/form/shippingUpload/index.vue';
export default {
  components: {
    ShippingUpload,
    OtherUpload,
    DownloadAll,
  },
  props: {
    goodType: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    shippingFileList: {
      type: Array,
      default: () => [],
    },
    otherFileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        if (this.goodType !== '4' && this.shippingFileList.length === 0) {
          ShowWarningMessage(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage'));
          reject(new Error(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage')));
        }

        if (this.otherFileList.length > 0) {
          const fileTypeCounts = this.otherFileList.reduce((acc, file) => {
            if (file.fileType) {
              acc[file.fileType] = (acc[file.fileType] || 0) + 1;
            }
            return acc;
          }, {});

          if (!this.otherFileList.every(file => file.fileType)) {
            ShowWarningMessage(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage1'));
            reject(new Error(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage1')));
          }

          if (Object.values(fileTypeCounts).some(count => count > 3)) {
            ShowWarningMessage(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage2'));
            reject(new Error(this.$t('message.refuse.klarnaRebutDrawer.uploadErrorMessage2')));
          }
        }
        resolve(true);
      });
    },
  },
  computed: {
    shippingFileListState: {
      get() {
        return this.shippingFileList;
      },
      set(newValue) {
        this.$emit('update:shippingFileList', newValue);
      },
    },
    otherFileListState: {
      get() {
        return this.otherFileList;
      },
      set(newValue) {
        this.$emit('update:otherFileList', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>

.title-text {
  font-family: Open Sans, Open Sans;
  font-weight: 400;
  font-size: 16px;
  color: #667085;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 8px;
}

.title-large {
  font-weight: bold !important;
  font-size: 32px !important;
  color: #1A202C !important;
  line-height: 40px !important;
  }

.card {
  margin-top: 32px;
}

.red-text {
  color: #FF0000;
}

</style>
